import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from '../models/types/selectable.type';
import { GetQuery } from '../../models/shared/enums/get-query.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from '../../models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from '../../models/shared/types/page-info.type';
import { Color } from '../../models/common/color.model';

@Injectable({
  providedIn: 'root'
})
export class ColorFilterService extends IFilterListService<Color> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables: any, isFirst: boolean): void {
    if (searchText || isFirst) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };
    const filters = { search: searchText, companyId: this.appService.companyId, first: variables.first, after: searchText ? null : this.pageInfo.endCursor, modelId: variables.modelId };
    
    this.graphQlService.getData<Color>(GetQuery.GET_COLORS_BY_MODEL, filters)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((res: any) => res['data']['colors'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<any>) => {
          let datasource: Array<Selectable<any>> = [];
          if (this.pageInfo.endCursor) {
            const actualValue = this.datasource.getValue();
            datasource = [...actualValue, ...res.nodes.map(el => ({ colorId: el.id, colorCode: el.Code, fullName: el.finalColorName, displayId: el.id!, displayName: el.finalColorName, disabled: false, selected: false }))];
          } else {
            datasource = res.nodes.map(el => ({ colorId: el.id, colorCode: el.Code, fullName: el.finalColorName, displayId: el.id!, displayName: el.finalColorName, disabled: false, selected: false }));
          }

          this.pageInfo = {...res.pageInfo};
          this.datasource.next(datasource);
        }
      })
  }
}
